import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailCompose from "../pages/Email/email-compose"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Dashboard
import Dashboard from "../pages/NavPages/Dashboard"

//Nav Pages
import MaterialUnit from "../pages/NavPages/MaterialUnitTypes"
import Roles from "./../pages/NavPages/roles"
import Users from "./../pages/NavPages/Users"
import CanTypes from "./../pages/NavPages/CanTypes"
import Designations from "./../pages/NavPages/Designations"
import BillCustomization from "pages/NavPages/BillCustomization"
import MapView from "pages/NavPages/MapView"
import Ratecharts from "pages/NavPages/Ratecharts"
import IncentiveCharts from "pages/NavPages/IncentiveCharts"
import CCIncentives from "pages/NavPages/CCIncentives"
import VLCCIncentives from "pages/NavPages/VLCCIncentives"
import VLCCPurchases from "pages/NavPages/VLCCPurchases"
import CCPurchases from "pages/NavPages/CCPurchases"
import CCSpoiledPurchases from "pages/NavPages/CCSpoiledPurchases"
import CenterMilkSales from "pages/NavPages/CenterMilkSales"
import MilkTransfers from "pages/NavPages/MilkTransfers"
import VLCC from "pages/NavPages/VLCC"
import CC from "pages/NavPages/CC"
import Bills from "./../pages/NavPages/Bills"
import VendorLoans from "pages/NavPages/VendorLoans"
import VendorCashAdvances from "pages/NavPages/VendorCashAdvances"
import VendorMaterialAdvances from "pages/NavPages/VendorMaterialAdvances"
import ProducerLoans from "pages/NavPages/ProducerLoans"
import ProducerCashAdvances from "pages/NavPages/ProducerCashAdvances"
import ProducerMaterialAdvances from "pages/NavPages/ProducerMaterialAdvances"
import VendorRecoveries from "pages/NavPages/VendorRecoveries"
import VendorAdditions from "pages/NavPages/VendorAdditions"
import ProducerRecoveries from "pages/NavPages/ProducerRecoveries"
import ProducerAdditions from "pages/NavPages/ProducerAdditions"
import ClientVehicleRecoveries from "pages/NavPages/ClientVehicleRecoveries"
import ClientVehicleAdditions from "pages/NavPages/ClientVehicleAdditions"
import Companies from "pages/NavPages/Companies"
import Plants from "pages/NavPages/Plants"
import ChillingCenters from "pages/NavPages/ChillingCenters"
import Routes from "pages/NavPages/Routes"
import CollectionCenterVLCC from "pages/NavPages/CollectionCenterVLCC"
import BulkVendors from "pages/NavPages/BulkVendors"
import BusinessVendors from "pages/NavPages/BusinessVendors"
import Producers from "pages/NavPages/Producers"
import Materials from "pages/NavPages/Materials"
import Staffs from "pages/NavPages/Staffs"
import Transporters from "pages/NavPages/Transporters"
import Vehicles from "pages/NavPages/Vehicles"
import AdditionsDeductions from "pages/NavPages/AdditionsDeductions"
import VLCCSummary from "pages/NavPages/VLCCSummary"
import CCSummary from "pages/NavPages/CCSummary"
import ProcurementSummary from "pages/NavPages/ProcurementSummary"
import ProcurementBillSummary from "pages/NavPages/ProcurementBillSummary"
import VendorAdvancesReport from "pages/NavPages/VendorAdvancesReport"
import ProducerAdvancesReport from "pages/NavPages/ProducerAdvancesReport"
import ProcurementAttendance from "pages/NavPages/ProcurementAttendance"
import CCvsVLCCcomparision from "pages/NavPages/CCvsVLCCcomparision"
import SMSReport from "pages/NavPages/SMSReport"
import SmsSettings from "pages/NavPages/SmsSettings"
import VendorCashAdvanceReport from "pages/NavPages/VendorCashAdvanceReport"
import VendorMaterialAdvanceReport from "pages/NavPages/VendorMaterialAdvanceReport"
import ProducerCashAdvanceReport from "pages/NavPages/ProducerCashAdvanceReport"
import ProducerMaterialAdvanceReport from "pages/NavPages/ProducerMaterialAdvanceReport"
import VLCCSettingsReport from "pages/NavPages/VLCCSettingsReport"
import CleaningReport from "pages/NavPages/CleaningReport"
import FundsReport from "pages/NavPages/FundsReport"
import VLCCRateChartStatusReport from "pages/NavPages/VLCCRateChartStatusReport"
import ProducerReport from "pages/NavPages/ProducerReport"
import MilkTransferReport from "pages/NavPages/MilkTransferReport"
import VLCCAbsentees from "pages/NavPages/VLCCAbsentees"
import ProcurementHistory from "pages/NavPages/ProcurementHistory"
import ProducerPerformance from "pages/NavPages/ProducerPerformance"
import RouteCollectionReport from "pages/NavPages/RouteCollectionReport"
import AdvanceSummary from "pages/NavPages/AdvanceSummary"
import PaymentReport from "pages/NavPages/PaymentReport"
import QualityAnalysis from "pages/NavPages/QualityAnalysis"
import CCvsVLCCReport from "pages/NavPages/CCvsVLCCReport"
import ChangePassword from "pages/NavPages/ChangePassword"
import AddUser from "pages/NavPages/AddUser"
import EditCanType from "pages/NavPages/Components/Edit-Forms/EditCanType"
import AddCanType from "pages/NavPages/Add-Forms/AddCanType"
import AddVendor from "pages/NavPages/Add-Forms/AddVendor"

//Extra Pages
import PagesTimeline from "../pages/Extra Pages/pages-timeline"
import PagesInvoice from "../pages/Extra Pages/pages-invoice"
import PagesDirectory from "../pages/Extra Pages/pages-directory"
import PagesBlank from "../pages/Extra Pages/pages-blank"
import Pages404 from "../pages/Extra Pages/pages-404"
import Pages500 from "../pages/Extra Pages/pages-500"
import EditDesignation from "pages/NavPages/Components/Edit-Forms/EditDesignation"
import AddDesignation from "pages/NavPages/Add-Forms/AddDesignation"
import AddMaterial from "pages/NavPages/Add-Forms/AddMaterial"
import EditMaterial from "pages/NavPages/Components/Edit-Forms/EditMaterial"
import AddRole from "pages/NavPages/Add-Forms/AddRole"
import EditRole from "pages/NavPages/Components/Edit-Forms/EditRole"
import AddCompany from "pages/NavPages/Add-Forms/AddCompany"
import EditCompany from "pages/NavPages/Components/Edit-Forms/EditCompany"
import AddPlant from "pages/NavPages/Add-Forms/AddPlant"
import EditPlant from "pages/NavPages/Components/Edit-Forms/EditPlant"
import AddCenter from "pages/NavPages/Add-Forms/AddCenter"
import EditCenter from "pages/NavPages/Components/Edit-Forms/EditCenter"
import AddRoute from "pages/NavPages/Add-Forms/AddRoute"
import EditRoute from "pages/NavPages/Components/Edit-Forms/EditRoute"
import AddCollection from "pages/NavPages/Add-Forms/AddCollection"
import EditCollection from "pages/NavPages/Components/Edit-Forms/EditCollection"
import EditVendor from "pages/NavPages/Components/Edit-Forms/EditVendor"
import AddProducer from "pages/NavPages/Add-Forms/AddProducer"
import EditProducer from "pages/NavPages/Components/Edit-Forms/EditProducer"
import AddStaff from "pages/NavPages/Add-Forms/AddStaff"
import EditStaff from "pages/NavPages/Components/Edit-Forms/EditStaff"
import AddMaterialBrand from "pages/NavPages/Add-Forms/AddMaterialBrand"
import EditMaterialBrand from "pages/NavPages/Components/Edit-Forms/EditMaterialBrand"
import AddTransporter from "pages/NavPages/Add-Forms/AddTransporter"
import EditTransporter from "pages/NavPages/Components/Edit-Forms/EditTransporter"
import AddVehicle from "pages/NavPages/Add-Forms/AddVehicle"
import EditVehicle from "pages/NavPages/Components/Edit-Forms/EditVehicle"
import AddBillCustomization from "pages/NavPages/Add-Forms/AddBillCustomization"
import AddVendorLoan from "pages/NavPages/Add-Forms/AddVendorLoan"
import EditVendorLoan from "pages/NavPages/Components/Edit-Forms/EditVendorLoan"
import AddVendorCashAdvance from "pages/NavPages/Add-Forms/AddVendorCashAdvance"
import EditVendorCashAdvance from "pages/NavPages/Components/Edit-Forms/EditVendorCashAdvance"
import AddProducerLoan from "pages/NavPages/Add-Forms/AddProducerLoan"
import EditProducerLoan from "pages/NavPages/Components/Edit-Forms/EditProducerLoan"
import AddProducerAdvance from "pages/NavPages/Add-Forms/AddProducerAdvance"
import EditProducerAdvance from "pages/NavPages/Components/Edit-Forms/EditProducerAdvance"
import AddVendorRecovery from "pages/NavPages/Add-Forms/AddVendorRecovery"
import EditVendorRecovery from "pages/NavPages/Components/Edit-Forms/EditVendorRecovery"
import AddProducerRecovery from "pages/NavPages/Add-Forms/AddProducerRecovery"
import EditProducerRecovery from "pages/NavPages/Components/Edit-Forms/EditProducerRecovery"
import AddRouteBill from "pages/NavPages/Add-Forms/AddRouteBill"
import EditRouteBill from "pages/NavPages/Components/Edit-Forms/EditRouteBill"
import DeleteAlert from "pages/NavPages/Components/DeleteAlert"
import DeleteSuccess from "pages/NavPages/Components/DeleteSuccess"
import AddRatechart from "pages/NavPages/Add-Forms/AddRatechart"
import EditRatechart from "pages/NavPages/Components/Edit-Forms/EditRatechart"
import AddIncentiveChart from "pages/NavPages/Add-Forms/AddIncentiveChart"
import EditIncentiveChart from "pages/NavPages/Components/Edit-Forms/EditIncentiveChart"
import EditVlccPurchase from "pages/NavPages/Components/Edit-Forms/EditVlccPurchase"
import AddMaterialCategory from "pages/NavPages/Add-Forms/AddMaterialCategory"
import EditMaterialCategory from "pages/NavPages/Components/Edit-Forms/EditMaterialCategory"
import AddMaterialItem from "pages/NavPages/Add-Forms/AddMaterialItem"
import EditMaterialItem from "pages/NavPages/Components/Edit-Forms/EditMaterialItem"
import Test from "pages/NavPages/Test"
import EditVlccSettings from "pages/NavPages/Components/Edit-Forms/EditVlccSettings"
import CompanySettings from "pages/NavPages/Components/Edit-Forms/CompanySettings"
import VlccMobileSettings from "pages/NavPages/VlccMobileSettings"
import VlccMobileLogin from "pages/NavPages/VlccMobileLogin"
import CcMobileSettings from "pages/NavPages/CcMobileSettings"
import CcMobileLogin from "pages/NavPages/CcMobileLogin"
import AddFundType from "pages/NavPages/Add-Forms/AddFundType"
import FundTypes from "pages/NavPages/FundTypes"
import EditFundType from "pages/NavPages/Components/Edit-Forms/EditFundType"
import AddIncentiveType from "pages/NavPages/Add-Forms/AddIncentiveType"
import IncentiveTypes from "pages/NavPages/IncentiveTypes"
import EditIncentiveType from "pages/NavPages/Components/Edit-Forms/EditIncentiveType"
import AddVlccPurchase from "pages/NavPages/Add-Forms/AddVlccPurchase"
import TransportBills from "pages/NavPages/TransportBills"
import AddTransportBill from "pages/NavPages/Add-Forms/AddTransportBill"
import VlccBonustBills from "pages/NavPages/VlccBonusBills"
import AddCenterBonusBill from "pages/NavPages/Add-Forms/AddCenterBonusBill"
import EditTransportBill from "pages/NavPages/Components/Edit-Forms/EditTransportBill"
import EditCenterBonusBill from "pages/NavPages/Components/Edit-Forms/EditCenterBonusBill"
import AddCcPurchase from "pages/NavPages/Add-Forms/AddCcPurchase"
import EditCcPurchase from "pages/NavPages/Components/Edit-Forms/EditCcPurchase"
import AddCcSpoiledPurchase from "pages/NavPages/Add-Forms/AddCcSpoiledPurchase"
import EditCcSpoiledPurchase from "pages/NavPages/Components/Edit-Forms/EditCcSpoiledPurchase"
import AddVendorMaterialAdvance from "pages/NavPages/Add-Forms/AddVendorMaterialAdvance"
import EditVendorMaterialAdvance from "pages/NavPages/Components/Edit-Forms/EditVendorMaterialAdvance"
import AddProducerMaterialAdvance from "pages/NavPages/Add-Forms/AddProducerMaterialAdvance"
import EditProducerMaterialAdvance from "pages/NavPages/Components/Edit-Forms/EditProducerMaterialAdvance"
import VehicleCashAdvances from "pages/NavPages/VehicleCashAdvances"
import AddVehicleCashAdvance from "pages/NavPages/Add-Forms/AddVehicleCashAdvance"
import EditVehicleCashAdvance from "pages/NavPages/Components/Edit-Forms/EditVehicleCashAdvance"
import PaymentDashboard from "pages/NavPages/PaymentDashboard"
import PaymentProcess from "pages/NavPages/PaymentProcess"
import PaymentLedger from "pages/NavPages/PaymentLedger"
import PaymentConfig from "pages/NavPages/PaymentConfig"
import ServiceTypes from "pages/NavPages/ServiceTypes"
import ServiceItems from "pages/NavPages/ServiceItems"
import AddServiceType from "pages/NavPages/Add-Forms/AddServiceType"
import EditServiceType from "pages/NavPages/Components/Edit-Forms/EditServiceType"
import AddServiceItem from "pages/NavPages/Add-Forms/AddServiceItem"
import EditServiceItem from "pages/NavPages/Components/Edit-Forms/EditServiceItem"

// Module IDs: 1=Dashboard, 2=Company, 3=Plants, 4=CC, 5=Routes, 6=VLCC, 7=Vendors,
// 8=Producers, 9=Materials, 10=Staffs, 11=Transporters, 12=Vehicles,
// 13=RateCharts, 14=IncentiveCharts, 15=CCIncentives, 16=VLCCIncentives,
// 17=VLCCPurchases, 18=CCPurchases, 19=CCSpoiled, 20=SessionStatus,
// 21=RouteBills, 22=TransportBills, 23=BonusBills,
// 24=VendorLoans, 25=VendorCashAdv, 26=VendorMatAdv,
// 27=ProducerLoans, 28=ProducerCashAdv, 29=ProducerMatAdv,
// 30=VendorRecoveries, 31=ProducerRecoveries,
// 32=MapView, 33=BillCustomization, 34=Roles&Users, 35=Configurations,
// 36=Reports, 37=GraphReports, 38=Payments, 39=SMSSettings,
// 40=VehicleCashAdvances

const userRoutes = [
  // ── Dashboard ──
  { path: "/dashboard", component: Dashboard, moduleId: 1, action: "view" },

  // ── Configurations (Module 35) ──
  { path: "/material-unit-type", component: MaterialUnit, moduleId: 35, action: "view" },
  { path: "/add-material-unit", component: AddMaterial, moduleId: 35, action: "add" },
  { path: "/edit-material-unit/:id", component: EditMaterial, moduleId: 35, action: "edit" },
  { path: "/can-types", component: CanTypes, moduleId: 35, action: "view" },
  { path: "/add-can-type", component: AddCanType, moduleId: 35, action: "add" },
  { path: "/edit-can-type/:id", component: EditCanType, moduleId: 35, action: "edit" },
  { path: "/designations", component: Designations, moduleId: 35, action: "view" },
  { path: "/add-designation", component: AddDesignation, moduleId: 35, action: "add" },
  { path: "/edit-designation/:id", component: EditDesignation, moduleId: 35, action: "edit" },
  { path: "/fundtypes", component: FundTypes, moduleId: 35, action: "view" },
  { path: "/add-fundtype", component: AddFundType, moduleId: 35, action: "add" },
  { path: "/edit-fundtype/:id", component: EditFundType, moduleId: 35, action: "edit" },
  { path: "/incentive-types", component: IncentiveTypes, moduleId: 35, action: "view" },
  { path: "/add-incentive-type", component: AddIncentiveType, moduleId: 35, action: "add" },
  { path: "/edit-incentive-type/:id", component: EditIncentiveType, moduleId: 35, action: "edit" },
  { path: "/sms-settings", component: SmsSettings, moduleId: 39, action: "view" },
  { path: "/service-types", component: ServiceTypes, moduleId: 35, action: "view" },
  { path: "/add-service-type", component: AddServiceType, moduleId: 35, action: "add" },
  { path: "/edit-service-type/:id", component: EditServiceType, moduleId: 35, action: "edit" },
  { path: "/service-items", component: ServiceItems, moduleId: 35, action: "view" },
  { path: "/add-service-item", component: AddServiceItem, moduleId: 35, action: "add" },
  { path: "/edit-service-item/:id", component: EditServiceItem, moduleId: 35, action: "edit" },

  // ── Roles & Users (Module 34) ──
  { path: "/roles", component: Roles, moduleId: 34, action: "view" },
  { path: "/add-role", component: AddRole, moduleId: 34, action: "add" },
  { path: "/edit-role/:id", component: EditRole, moduleId: 34, action: "edit" },
  { path: "/users", component: Users, moduleId: 34, action: "view" },
  { path: "/add-user", component: AddUser, moduleId: 34, action: "add" },

  // ── Customization (Module 33) ──
  { path: "/bill-customization", component: BillCustomization, moduleId: 33, action: "view" },
  { path: "/add-bill-customization/:id", component: AddBillCustomization, moduleId: 33, action: "add" },

  // ── Map View (Module 32) ──
  { path: "/map-view", component: MapView, moduleId: 32, action: "view" },

  // ── Rate Charts (Module 13) ──
  { path: "/rate-charts", component: Ratecharts, moduleId: 13, action: "view" },
  { path: "/add-ratechart", component: AddRatechart, moduleId: 13, action: "add" },
  { path: "/edit-ratechart/:id", component: EditRatechart, moduleId: 13, action: "edit" },

  // ── Incentives (Modules 14-16) ──
  { path: "/incentive-charts", component: IncentiveCharts, moduleId: 14, action: "view" },
  { path: "/add-incentive-chart", component: AddIncentiveChart, moduleId: 14, action: "add" },
  { path: "/edit-incentive-chart/:id", component: EditIncentiveChart, moduleId: 14, action: "edit" },
  { path: "/cc-incentives", component: CCIncentives, moduleId: 15, action: "view" },
  { path: "/vlcc-incentives", component: VLCCIncentives, moduleId: 16, action: "view" },

  // ── Procurement (Modules 17-19) ──
  { path: "/vlcc-purchases", component: VLCCPurchases, moduleId: 17, action: "view" },
  { path: "/add-vlcc-purchase", component: AddVlccPurchase, moduleId: 17, action: "add" },
  { path: "/edit-vlcc-purchase/:id", component: EditVlccPurchase, moduleId: 17, action: "edit" },
  { path: "/cc-purchases", component: CCPurchases, moduleId: 18, action: "view" },
  { path: "/add-cc-purchase", component: AddCcPurchase, moduleId: 18, action: "add" },
  { path: "/edit-cc-purchase/:id", component: EditCcPurchase, moduleId: 18, action: "edit" },
  { path: "/cc-spoiled-purchases", component: CCSpoiledPurchases, moduleId: 19, action: "view" },
  { path: "/add-cc-spoiled-purchase", component: AddCcSpoiledPurchase, moduleId: 19, action: "add" },
  { path: "/edit-cc-spoiled-purchase/:id", component: EditCcSpoiledPurchase, moduleId: 19, action: "edit" },
  { path: "/center-milk-sales", component: CenterMilkSales, moduleId: 41, action: "view" },
  { path: "/milk-transfers", component: MilkTransfers, moduleId: 42, action: "view" },

  // ── Session Status (Module 20) ──
  { path: "/vlcc", component: VLCC, moduleId: 20, action: "view" },
  { path: "/cc", component: CC, moduleId: 20, action: "view" },
  { path: "/vlcc-mobile-settings/:ccId", component: VlccMobileSettings, moduleId: 20, action: "view" },
  { path: "/vlcc-mobile-login/:ccId", component: VlccMobileLogin, moduleId: 20, action: "view" },
  { path: "/cc-mobile-settings/:ccId", component: CcMobileSettings, moduleId: 4, action: "view" },
  { path: "/cc-mobile-login/:ccId", component: CcMobileLogin, moduleId: 4, action: "view" },
  { path: "/edit-vlcc-settings/:id", component: EditVlccSettings, moduleId: 20, action: "edit" },

  // ── Bills (Modules 21-23) ──
  { path: "/bills", component: Bills, moduleId: 21, action: "view" },
  { path: "/add-route-bill", component: AddRouteBill, moduleId: 21, action: "add" },
  { path: "/edit-route-bill/:id", component: EditRouteBill, moduleId: 21, action: "edit" },
  { path: "/transport-bills", component: TransportBills, moduleId: 22, action: "view" },
  { path: "/add-transport-bill", component: AddTransportBill, moduleId: 22, action: "add" },
  { path: "/edit-transport-bill/:id", component: EditTransportBill, moduleId: 22, action: "edit" },
  { path: "/vlcc-bonus-bills", component: VlccBonustBills, moduleId: 23, action: "view" },
  { path: "/add-center-bonus-bill", component: AddCenterBonusBill, moduleId: 23, action: "add" },
  { path: "/edit-center-bonus-bill/:id", component: EditCenterBonusBill, moduleId: 23, action: "edit" },

  // ── Payment System (Module 38) ──
  { path: "/payment-dashboard", component: PaymentDashboard, moduleId: 38, action: "view" },
  { path: "/payment-process", component: PaymentProcess, moduleId: 38, action: "approve" },
  { path: "/payment-ledger", component: PaymentLedger, moduleId: 38, action: "view" },
  { path: "/payment-config", component: PaymentConfig, moduleId: 38, action: "edit" },

  // ── Finance - Advances (Modules 24-29) ──
  { path: "/vendor-loans", component: VendorLoans, moduleId: 24, action: "view" },
  { path: "/add-vendor-loan", component: AddVendorLoan, moduleId: 24, action: "add" },
  { path: "/edit-vendor-loan/:id", component: EditVendorLoan, moduleId: 24, action: "edit" },
  { path: "/vendor-cash-advances", component: VendorCashAdvances, moduleId: 25, action: "view" },
  { path: "/add-vendor-cash-advance", component: AddVendorCashAdvance, moduleId: 25, action: "add" },
  { path: "/edit-vendor-cash-advance/:id", component: EditVendorCashAdvance, moduleId: 25, action: "edit" },
  { path: "/vendor-material-advances", component: VendorMaterialAdvances, moduleId: 26, action: "view" },
  { path: "/add-vendor-material-advance", component: AddVendorMaterialAdvance, moduleId: 26, action: "add" },
  { path: "/edit-vendor-material-advance/:id", component: EditVendorMaterialAdvance, moduleId: 26, action: "edit" },
  { path: "/producer-loans", component: ProducerLoans, moduleId: 27, action: "view" },
  { path: "/add-producer-loan", component: AddProducerLoan, moduleId: 27, action: "add" },
  { path: "/edit-producer-loan/:id", component: EditProducerLoan, moduleId: 27, action: "edit" },
  { path: "/producer-cash-advances", component: ProducerCashAdvances, moduleId: 28, action: "view" },
  { path: "/add-producer-cash-advance", component: AddProducerAdvance, moduleId: 28, action: "add" },
  { path: "/edit-producer-cash-advance/:id", component: EditProducerAdvance, moduleId: 28, action: "edit" },
  { path: "/producer-material-advances", component: ProducerMaterialAdvances, moduleId: 29, action: "view" },
  { path: "/add-producer-material-advance", component: AddProducerMaterialAdvance, moduleId: 29, action: "add" },
  { path: "/edit-producer-material-advance/:id", component: EditProducerMaterialAdvance, moduleId: 29, action: "edit" },
  { path: "/vehicle-cash-advances", component: VehicleCashAdvances, moduleId: 40, action: "view" },
  { path: "/add-vehicle-cash-advance", component: AddVehicleCashAdvance, moduleId: 40, action: "add" },
  { path: "/edit-vehicle-cash-advance/:id", component: EditVehicleCashAdvance, moduleId: 40, action: "edit" },

  // ── Finance - Recoveries (Modules 30-31) ──
  { path: "/vendor-recoveries", component: VendorRecoveries, moduleId: 30, action: "view" },
  { path: "/add-vendor-recovery", component: AddVendorRecovery, moduleId: 30, action: "add" },
  { path: "/edit-vendor-recovery/:id", component: EditVendorRecovery, moduleId: 30, action: "edit" },
  { path: "/vendor-additions", component: VendorAdditions, moduleId: 30, action: "view" },
  { path: "/producer-recoveries", component: ProducerRecoveries, moduleId: 31, action: "view" },
  { path: "/add-producer-recovery", component: AddProducerRecovery, moduleId: 31, action: "add" },
  { path: "/edit-producer-recovery/:id", component: EditProducerRecovery, moduleId: 31, action: "edit" },
  { path: "/producer-additions", component: ProducerAdditions, moduleId: 31, action: "view" },
  { path: "/client-vehicle-recoveries", component: ClientVehicleRecoveries, moduleId: 12, action: "view" },
  { path: "/client-vehicle-additions", component: ClientVehicleAdditions, moduleId: 12, action: "view" },

  // ── Masters (Modules 2-12) ──
  { path: "/companies", component: Companies, moduleId: 2, action: "view" },
  { path: "/add-company", component: AddCompany, moduleId: 2, action: "add" },
  { path: "/edit-company/:id", component: EditCompany, moduleId: 2, action: "edit" },
  { path: "/company-settings/:id", component: CompanySettings, moduleId: 2, action: "edit" },
  { path: "/plants", component: Plants, moduleId: 3, action: "view" },
  { path: "/add-plant", component: AddPlant, moduleId: 3, action: "add" },
  { path: "/edit-plant/:id", component: EditPlant, moduleId: 3, action: "edit" },
  { path: "/chilling-centers", component: ChillingCenters, moduleId: 4, action: "view" },
  { path: "/add-center", component: AddCenter, moduleId: 4, action: "add" },
  { path: "/edit-center/:id", component: EditCenter, moduleId: 4, action: "edit" },
  { path: "/routes", component: Routes, moduleId: 5, action: "view" },
  { path: "/add-route", component: AddRoute, moduleId: 5, action: "add" },
  { path: "/edit-route/:id", component: EditRoute, moduleId: 5, action: "edit" },
  { path: "/collection-center-vlcc", component: CollectionCenterVLCC, moduleId: 6, action: "view" },
  { path: "/add-collection-center", component: AddCollection, moduleId: 6, action: "add" },
  { path: "/edit-collection-center/:id", component: EditCollection, moduleId: 6, action: "edit" },
  { path: "/bulk-vendors", component: BulkVendors, moduleId: 7, action: "view" },
  { path: "/add-vendor", component: AddVendor, moduleId: 7, action: "add" },
  { path: "/edit-vendor/:id", component: EditVendor, moduleId: 7, action: "edit" },
  { path: "/business-vendors", component: BusinessVendors, moduleId: 7, action: "view" },
  { path: "/producers", component: Producers, moduleId: 8, action: "view" },
  { path: "/add-producer", component: AddProducer, moduleId: 8, action: "add" },
  { path: "/edit-producer/:id", component: EditProducer, moduleId: 8, action: "edit" },
  { path: "/materials", component: Materials, moduleId: 9, action: "view" },
  { path: "/add-material", component: AddMaterialBrand, moduleId: 9, action: "add" },
  { path: "/edit-material/:id", component: EditMaterialBrand, moduleId: 9, action: "edit" },
  { path: "/add-material-category", component: AddMaterialCategory, moduleId: 9, action: "add" },
  { path: "/edit-material-category/:id", component: EditMaterialCategory, moduleId: 9, action: "edit" },
  { path: "/add-material-item", component: AddMaterialItem, moduleId: 9, action: "add" },
  { path: "/edit-material-item/:id", component: EditMaterialItem, moduleId: 9, action: "edit" },
  { path: "/staffs", component: Staffs, moduleId: 10, action: "view" },
  { path: "/add-staff", component: AddStaff, moduleId: 10, action: "add" },
  { path: "/edit-staff/:id", component: EditStaff, moduleId: 10, action: "edit" },
  { path: "/transporters", component: Transporters, moduleId: 11, action: "view" },
  { path: "/add-transporter", component: AddTransporter, moduleId: 11, action: "add" },
  { path: "/edit-transporter/:id", component: EditTransporter, moduleId: 11, action: "edit" },
  { path: "/vehicles", component: Vehicles, moduleId: 12, action: "view" },
  { path: "/additions-deductions", component: AdditionsDeductions, moduleId: 12, action: "view" },
  { path: "/add-vehicle", component: AddVehicle, moduleId: 12, action: "add" },
  { path: "/edit-vehicle/:id", component: EditVehicle, moduleId: 12, action: "edit" },

  // ── Reports (Module 36) ──
  { path: "/procurement-summary", component: ProcurementSummary, moduleId: 36, action: "view" },
  { path: "/vlcc-summary", component: ProcurementSummary, moduleId: 36, action: "view" },
  { path: "/cc-summary", component: ProcurementSummary, moduleId: 36, action: "view" },
  { path: "/cc-vlcc-comparision", component: CCvsVLCCcomparision, moduleId: 36, action: "view" },
  { path: "/procurement-bill-summary", component: ProcurementBillSummary, moduleId: 36, action: "view" },
  { path: "/sms-report", component: SMSReport, moduleId: 36, action: "view" },
  { path: "/vendor-cashadvance-report", component: VendorAdvancesReport, moduleId: 36, action: "view" },
  { path: "/vendor-materialadvance-report", component: VendorAdvancesReport, moduleId: 36, action: "view" },
  { path: "/vendor-advances-report", component: VendorAdvancesReport, moduleId: 36, action: "view" },
  { path: "/producer-cashadvance-report", component: ProducerAdvancesReport, moduleId: 36, action: "view" },
  { path: "/producer-materialadvance-report", component: ProducerAdvancesReport, moduleId: 36, action: "view" },
  { path: "/producer-advances-report", component: ProducerAdvancesReport, moduleId: 36, action: "view" },
  { path: "/vlcc-settings-report", component: VLCCSettingsReport, moduleId: 36, action: "view" },
  { path: "/cleaning-report", component: CleaningReport, moduleId: 36, action: "view" },
  { path: "/vlcc-absentees", component: VLCCAbsentees, moduleId: 36, action: "view" },
  { path: "/producer-performance", component: ProducerPerformance, moduleId: 36, action: "view" },
  { path: "/route-collection", component: RouteCollectionReport, moduleId: 36, action: "view" },
  { path: "/advance-summary", component: AdvanceSummary, moduleId: 36, action: "view" },
  { path: "/payment-report", component: PaymentReport, moduleId: 36, action: "view" },
  { path: "/procurement-attendance", component: ProcurementAttendance, moduleId: 36, action: "view" },
  { path: "/funds-report", component: FundsReport, moduleId: 36, action: "view" },
  { path: "/vlcc-ratechart-status", component: VLCCRateChartStatusReport, moduleId: 36, action: "view" },
  { path: "/producer-report", component: ProducerReport, moduleId: 36, action: "view" },
  { path: "/milk-transfer-report", component: MilkTransferReport, moduleId: 36, action: "view" },

  // ── Graph Reports (Module 37) ──
  { path: "/procurement-history", component: ProcurementHistory, moduleId: 37, action: "view" },
  { path: "/quality-analysis", component: QualityAnalysis, moduleId: 37, action: "view" },
  { path: "/cc-vs-vlcc", component: CCvsVLCCReport, moduleId: 37, action: "view" },

  // ── Unprotected routes (no module restriction) ──
  { path: "/change-password", component: ChangePassword },
  { path: "/profile", component: UserProfile },
  { path: "/test", component: Test },
  { path: "/add-file", component: DeleteSuccess },
  { path: "/calendar", component: Calendar },
  { path: "/email-inbox", component: EmailInbox },
  { path: "/email-read", component: EmailRead },
  { path: "/email-compose", component: EmailCompose },
  { path: "/pages-timeline", component: PagesTimeline },
  { path: "/pages-invoice", component: PagesInvoice },
  { path: "/pages-directory", component: PagesDirectory },
  { path: "/pages-blank", component: PagesBlank },

  { path: "*", component: () => <Redirect to="/dashboard" /> },
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
  { path: "/pages-login", component: Login1 },
  { path: "/pages-register", component: Register1 },
  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/auth-lock-screen", component: LockScreen },
]

export { userRoutes, authRoutes }
